module.exports = {"320924100":"合德镇","320924101":"临海镇","320924102":"千秋镇","320924104":"四明镇","320924106":"海河镇","320924108":"海通镇","320924109":"兴桥镇","320924110":"新坍镇","320924111":"长荡镇","320924112":"盘湾镇","320924113":"特庸镇","320924114":"洋马镇","320924117":"黄沙港镇","320924400":"县经济开发区","320924401":"淮海农场","320924402":"临海农场","320924403":"新洋农场","320924404":"盐场","320924406":"射阳港经济区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320924.json
// module id = 910
// module chunks = 0